<template>
  <div class="addHappinessTipsComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="row">
      <div class="formulario col-sm-6 col-md-10">
        <v-form ref="form" lazy-validation class="mt-5 col-sm-10 col-md-6">
          <v-text-field
            :outlined="false"
            :filled="false"
            :solo="false"
            :label="'*'+$t('happinessTips.label.table.title')"
            :placeholder="$t('happinessTips.label.form.titlePlaceholder')" 
            :counter="50"
            :maxlength="50"
            required
            :rules="titleRules"
            v-model="formData.title"
            class="linea-inferior-pura"
          ></v-text-field>

          <v-select
            :outlined="false"
            :filled="false"
            :solo="false"
            :label="'*'+$t('happinessTips.label.table.category')"
            :items="categories"
            item-text="happinessCategoryTipsName"
            item-value="happinessCategoryTipsId"
            required
            :rules="categoryRules"
            v-model="formData.happinessCategoryTipsId"
            class="mt-5 linea-inferior-pura"
          ></v-select>

          <div class="add-image">
            <span class="text-image">{{ $t('happinessTips.label.form.miniature') }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs" v-on="on">
                  <label for="miniature-input">
                    <v-icon dark>mdi-plus</v-icon>
                  </label>
                </v-btn>
              </template>
              <span>{{ $t('label.image.text') }}</span>
              <input type="file" @change="onMiniatureChange" id="miniature-input" accept="image/png, image/jpeg, image/webp" style="display: none" />
            </v-tooltip>
          </div>
          <div v-if="formData.miniature" class="image-preview">
            <img v-if="allowedImageTypes.includes(formData.miniature.type)" :src="generateImageUrlPreview(formData.miniature)" alt="Miniatura" />
            <img v-else :src="formData.miniature" alt="Miniatura" />
          </div>

          <div class="add-image">
            <span class="text-image">{{ $t('happinessTips.label.form.detail') }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs" v-on="on">
                  <label for="detail-input">
                    <v-icon dark>mdi-plus</v-icon>
                  </label>
                </v-btn>
              </template>
              <span>{{ $t('label.image.text') }}</span>
              <input type="file" @change="onDetailChange" id="detail-input" accept="image/png, image/jpeg, image/webp" style="display: none" />
            </v-tooltip>
          </div>
          <div v-if="formData.detail" class="image-preview">
            <img v-if="allowedImageTypes.includes(formData.detail.type)" :src="generateImageUrlPreview(formData.detail)" alt="Detalle" />
            <img v-else :src="formData.detail" alt="Detalle" />
          </div>

          <v-file-input
            :outlined="false"
            :filled="false"
            :solo="false"
            :label="$t('happinessTips.label.form.fileLink')"
            accept="application/pdf"
            v-model="formData.fileLink"
            class="mt-5 linea-inferior-pura"
            @change="onFileLinkChange"
          ></v-file-input>

          <v-select
            v-model="formData.active"
            :label="$t('tips.label.table.status')"
            :items="listStatus"
            item-text="nameStatus"
            item-value="valueStatus"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            class="mt-5 linea-inferior-pura"
          ></v-select>
        </v-form>
      </div>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            fixed
            bottom
            right
            dark
            large
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="submitForm"
          >
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('button.save') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';

import {
  HAPPINESS_TIPS_M,
  GET_STATE_LOADING,
  GET_HAPPINESS_TIPS,
  ACTION_PUT_UPDATE_HAPPINESS_TIPS,
} from "@/views/happiness-tips/store/types/types.js";
import {
  TIPS_M,
  GET_TIPS as GET_CATEGORIES,
  ACTION_GET_TIPS as ACTION_GET_CATEGORIES,
} from "@/views/tips-categories/store/types/types.js";

import Swal from "sweetalert2";
export default {
  name: "detailHappinessTipsComponent",
  props: {
    happinessTips: {
      required: true,
    },
  },
  data() {
    return {
      formData: {
        idTip: this.happinessTips.idTip,
        title: this.happinessTips.title,
        message: this.happinessTips.message,
        happinessCategoryTipsId: this.happinessTips.happinessCategoryTipsId,
        miniature: this.happinessTips.miniatureUrl || null,
        detail: this.happinessTips.detailUrl || null,
        fileLink: null,
        active: this.happinessTips.active !== undefined ? this.happinessTips.active : true,
      },
      listStatus: [
        {
          idStatus: 1,
          nameStatus: 'Visible',
          valueStatus: true
        },
        {
          idStatus: 2,
          nameStatus: 'Oculto',
          valueStatus: false
        }
      ],
      allowedImageTypes: [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
        "image/svg+xml",
      ],
      titleRules: [
        v => !!v || i18n.t('happinessTips.label.form.titleRequired'),
        v => (v && v.length <= 50) || i18n.t('happinessTips.label.form.titleMaxLength'),
        v => !this.happinessTips.some(t => t.title && t.title.toLowerCase() === v.toLowerCase() && t.idTip !== this.happinessTips.idTip) || i18n.t('happinessTips.label.form.titleDuplicate'),
      ],
      categoryRules: [
        v => !!v || i18n.t('happinessTips.label.form.categoryRequired'),
      ],
      showErrorMessages: false,
    };
  },

  computed: {
    ...mapGetters({
      loading: [`${HAPPINESS_TIPS_M}${GET_STATE_LOADING}`],
      categories: [`${TIPS_M}${GET_CATEGORIES}`],
      happinessTips: `${HAPPINESS_TIPS_M}${GET_HAPPINESS_TIPS}`,
    }),
  },

  methods: {
    ...mapActions({
      putActionUpdateHappinessTips: `${HAPPINESS_TIPS_M}${ACTION_PUT_UPDATE_HAPPINESS_TIPS}`,
      getActionCategories: `${TIPS_M}${ACTION_GET_CATEGORIES}`,
    }),

    async submitForm() {
      try {
        const result = await Swal.fire({
          title: i18n.t('label.confirm.title'),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: i18n.t('button.save.text'),
          cancelButtonText: i18n.t('button.cancel.text'),
          confirmButtonColor: '#6E17A5'
        });
        if (result.isConfirmed) {

          const validationErrors = this.validateForm();

          if (Object.keys(validationErrors).length > 0) {
            const errorMessages = Object.values(validationErrors).join("<br>");
            Swal.fire({
              icon: 'error',
              title: i18n.t('label.errorsValidation.plural.title'),
              html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
              confirmButtonColor: '#6E17A5'
            });
            return;
          }

          const save = await this.putActionUpdateHappinessTips(this.formData);
          if (!save) {
            return Swal.fire({
              icon: 'error',
              title: i18n.t('label.invalid.title'),
              text: i18n.t('label.invalid.text')
            });
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
        }
        EventBus.$emit("reload-update-happiness-tips");
      } catch (error) {
        console.error(i18n.t('label.failService'));
      }
    },

    validateForm() {
      this.showErrorMessages = true;
      const errors = {};

      if (!this.formData.title || !this.formData.title.trim() || this.formData.title.length > 100) {
          errors.title = this.$t('happinessTips.label.table.title');
      }

      if (!this.formData.happinessCategoryTipsId) {
          errors.happinessCategoryTipsId = this.$t('happinessTips.label.table.category');
      }

      return errors;
    },
    onMiniatureChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!this.allowedImageTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.image.invalid')
        });
        return;
      }
      const fileSizeMB = file.size / (1024 * 1024);
      const maxFileSizeMB = 1;
      if (fileSizeMB > maxFileSizeMB) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imagesize.text', { maxSize: maxFileSizeMB })
        });
        return;
      }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
    URL.revokeObjectURL(img.src);
    const width = img.width;
    const height = img.height;

    if (width !== height) {
        Swal.fire({
        icon: 'error',
        title: i18n.t('label.errorsValidation.singular.title'),
        text: i18n.t('label.errorsValidation.squareimage.text', { w: width, h: height })
        });
    event.target.value = '';
    return;
  }

        this.formData.miniature = file;
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imageerror.text'),
        });
      };
    },
    onDetailChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!this.allowedImageTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.image.invalid')
        });
        return;
      }
      const fileSizeMB = file.size / (1024 * 1024);
      const maxFileSizeMB = 1;
      if (fileSizeMB > maxFileSizeMB) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imagesize.text', { max: maxFileSizeMB })
        });
        return;
      }

      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(img.src);
        const width = img.width;
        const height = img.height;

      if (height <= width) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.verticalimage.text', { w: width, h: height })
        });
        event.target.value = '';
        return;
      }

      this.formData.detail = file;
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imageerror.text'),
        });
      };
    },
    generateImageUrlPreview(file) {
      const preview = URL.createObjectURL(file);
      return preview;
    },
    onFileLinkChange(file) {
      if (!file) return;
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorFormatFile'),
        }).then(() => {
          this.formData.fileLink = null;
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
          });
        });
        return;
      }
      const fileSizeMB = file.size / (1024 * 1024);
      const maxFileSizeMB = 1;
      if (fileSizeMB > maxFileSizeMB) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.singular.title'),
          text: i18n.t('label.errorsValidation.imagesize.text', { max: maxFileSizeMB })
        }).then(() => {
          this.formData.fileLink = null;
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
          });
        });
        return;
      }
    },
  },
  async mounted() {
    await this.getActionCategories();
  },
};
</script>

<style lang="css" scoped>
.formulario {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5vw;
}

.row {
  display: flex;
  justify-content: center;
}

.add-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.text-image {
  color: #ff7900;
  margin-bottom: 10px;
}

.image-preview {
  margin-top: 10px;
  text-align: center;
}

.image-preview img {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  object-fit: cover;
}

.linea-inferior-pura ::v-deep fieldset {
  display: none !important;
  border: none !important;
}

.linea-inferior-pura ::v-deep .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.linea-inferior-pura.v-input--is-focused ::v-deep .v-input__slot {
  border-bottom: 2px solid #6e17a5 !important;
}

@media screen and (max-width: 425px) {
  .formulario {
    gap: 10px;
    display: flex;
    flex-direction: column-reverse;
  }
}
</style>
